
export const backendApiCall = async (
    apiPath,
    body,
    setFn,
    setLoadingFn,
    token,
    baseUrl
  ) => {
    setLoadingFn(true);
    try {
      const res = await fetch(`${baseUrl}api/cosmetic-rank/${apiPath}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body,
      });
      const data = await res.json();
      setFn(data);
    } catch (err) {
      console.error("API fetch error:", err);
    } finally {
      setLoadingFn(false);
    }
  };